import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchAgencyLinks } from '@rsos/reduxDataStore/src/features/peerAgencies/peerAgenciesSlice';
import isAgencyShareChatEnabled from '@rsos/utils/isAgencyShareChatEnabled';

const useFetchAgencyLinks = () => {
  const dispatch = useDispatch();

  const psaps = useSelector(state => state.psaps);

  const sinatra = useSelector(state => state.sinatra);

  const currentOrgName = sinatra.user.currentOrg.name;

  const hasAgencyShareChatAccess = useMemo(
    () => isAgencyShareChatEnabled(psaps),
    [psaps],
  );

  useEffect(() => {
    if (currentOrgName && hasAgencyShareChatAccess)
      dispatch(fetchAgencyLinks(currentOrgName));
  }, [currentOrgName, dispatch, hasAgencyShareChatAccess]);
};

export default useFetchAgencyLinks;
